/**
 * Variant Gate
 * - No variant pre-selected on page load
 * - Clicking Add to Cart or Buy it Now shows inline message + highlights variant picker
 */
(function () {
  'use strict';

  function init() {
    var sectionEl = document.querySelector('product-info[id^="MainProduct"]');
    if (!sectionEl) return;

    var variantSelects = sectionEl.querySelector('variant-selects');
    if (!variantSelects) return;

    var productForm = sectionEl.querySelector('product-form');
    if (!productForm) return;

    var form = productForm.querySelector('form');
    var submitBtn = productForm.querySelector('[type="submit"]');
    var buttonsWrap = productForm.querySelector('.product-form__buttons');

    if (new URLSearchParams(window.location.search).has('variant')) return;

    var variantSelected = false;

    // ── 1. Visually deselect all variant options ──
    variantSelects.querySelectorAll('input[type="radio"]').forEach(function (r) {
      r.checked = false;
    });
    variantSelects.querySelectorAll('[data-selected-value]').forEach(function (el) {
      el.textContent = '';
    });

    // ── 2. Create inline message element ──
    var msg = document.createElement('div');
    msg.className = 'vg-inline-msg';
    msg.textContent = 'Please select a variant';
    buttonsWrap.parentNode.insertBefore(msg, buttonsWrap);

    // ── 3. Show message + highlight picker ──
    function showWarning() {
      msg.classList.add('vg-inline-msg--visible');

      variantSelects.scrollIntoView({ behavior: 'smooth', block: 'center' });

      // Pulse the variant pill labels
      var pills = variantSelects.querySelectorAll('label');
      pills.forEach(function (pill) { pill.classList.add('vg-pill-pulse'); });
      setTimeout(function () {
        pills.forEach(function (pill) { pill.classList.remove('vg-pill-pulse'); });
      }, 2000);

      clearTimeout(msg._timer);
      msg._timer = setTimeout(function () {
        msg.classList.remove('vg-inline-msg--visible');
      }, 3000);
    }

    // ── 4. Unlock on variant selection ──
    variantSelects.addEventListener('change', function () {
      variantSelected = true;
      msg.classList.remove('vg-inline-msg--visible');
    });

    // ── 5. Intercept Add to Cart ──
    form.addEventListener('submit', function (e) {
      if (!variantSelected) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showWarning();
      }
    }, true);

    if (submitBtn) {
      submitBtn.addEventListener('click', function (e) {
        if (!variantSelected) {
          e.preventDefault();
          e.stopImmediatePropagation();
          showWarning();
        }
      }, true);
    }

    // ── 6. Intercept Buy it Now ──
    if (buttonsWrap) {
      buttonsWrap.addEventListener('click', function (e) {
        if (variantSelected) return;

        var target = e.target;
        while (target && target !== buttonsWrap) {
          if (target.classList && (
            target.classList.contains('shopify-payment-button') ||
            target.classList.contains('shopify-payment-button__button') ||
            target.classList.contains('shopify-payment-button__button--unbranded')
          )) {
            e.preventDefault();
            e.stopImmediatePropagation();
            showWarning();
            return;
          }
          target = target.parentElement;
        }
      }, true);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 100);
  }
})();
